<template>
    <b-container>
        <b-row class="mb-3">
            <b-col cols="6" lg="3">
                <DateInput v-model="fromDate"></DateInput>
            </b-col>
            <b-col cols="6" lg="3">
                <DateInput v-model="toDate"></DateInput>
            </b-col>
            <b-col cols="6" lg="3">
                <b-form-select v-model="interval" :options="intervalOptions"></b-form-select>
            </b-col>
<!--            <b-col cols="6" lg="6">-->
<!--                <b-form-select v-model="filterOption" :options="filterOptions"></b-form-select>-->
<!--            </b-col>-->
            <b-col cols="6" lg="3">
                <b-button-group block class="w-100">
                    <b-button @click="getData">{{$t('admin_report.show_report')}}</b-button>
                    <b-button variant="light" @click="exportData">
                        <font-awesome-icon icon="file-export"></font-awesome-icon>
                    </b-button>
                </b-button-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <BarChart :chart-data="chartData" :height="200"></BarChart>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    import {DateTime} from 'luxon'
    import BarChart from "./BarChart";
    import DateInput from "../DateInput";
    import _ from 'lodash';
    import {library} from '@fortawesome/fontawesome-svg-core'
    import {faFileExport} from '@fortawesome/free-solid-svg-icons'

    library.add(faFileExport);

    export default {
        name: 'AccBookingReport',
        components: {DateInput, BarChart},
        data() {
            return {
                fromDate: DateTime.local().startOf('year').toISO(),
                toDate: DateTime.local().endOf('year').toISO(),
                interval: 1,
                intervalOptions: [
                    {value: 1, text: this.$t('admin_report.interval_month')},
                    {value: 12, text: this.$t('admin_report.interval_year')},
                ],
                filterOption: {facilityTypeId: null, regionId: null, groupBy: null},
                regions: [],
                facilityTypes: [],
                rawData: null,
            }
        },
        computed: {
            filterOptions() {
                let regions = _.concat(
                    [
                        {value: null, disabled: true, text: this.$t('admin_acc_region.title')},
                        {value: {facilityTypeId: null, regionId: null, groupBy: 'category'}, text: this.$t('admin_report.all_regions')},
                    ],
                    this.regions.map(function (r) {
                        return {value: {facilityTypeId: null, regionId: r.id, groupBy: 'region'}, text: r.name};
                    }),
                );

                let facilityTypes = _.concat(
                    [
                        {value: null, disabled: true, text: this.$t('admin_acc_facility_type.title')},
                        {value: {facilityTypeId: null, regionId: null, groupBy: 'event'}, text: this.$t('admin_report.all_facility_types')},
                    ],
                    this.facilityTypes.map(function (t) {
                        return {value: {facilityTypeId: t.id, regionId: null, groupBy: 'facility_type'}, text: t.name};
                    }),
                );

                return _.concat(
                    [{value: {facilityTypeId: null, regionId: null, groupBy: null}, text: this.$t('admin_report.no_grouping')}],
                    regions,
                    facilityTypes,
                );
            },
            chartData() {
                if (!this.rawData) {
                    return {}
                }

                let datasets = [];
                let v = this;
                [
                    'confirmed',
                    'cancelled_by_user',
                    'cancelled_by_admin',
                    'refunded',
                    'no_show',
                ].forEach(function (t) {
                    let color = 'rgba(' + Math.floor(Math.random() * Math.floor(255)) + ', ' + Math.floor(Math.random() * Math.floor(255)) + ', ' + Math.floor(Math.random() * Math.floor(255)) + ', 0.5)';

                    let data = v.rawData[t].map(function (d) {
                        // return Math.floor(Math.random() * Math.floor(10));
                        return d.value;
                    });

                    datasets.push({
                        backgroundColor: color,
                        label: v.$t('admin_report.' + t),
                        data: data,
                    });
                });

                let labels = this.rawData['confirmed'].map(function (d) {
                    return d.label;
                });

                return {
                    labels: labels,
                    datasets: datasets,
                }
            },
        },
        mounted() {
            this.getRegions();
            this.getFacilityTypes();
        },
        watch: {
            // fromDate(newValue) {
            //     if (this.fromDate && this.toDate) {
            //         this.getEvents();
            //     }
            // },
            // toDate(newValue) {
            //     if (this.fromDate && this.toDate) {
            //         this.getEvents();
            //     }
            // },
        },
        methods: {
            getRegions() {
                this.$callAPI('room/region/', {}, function (response) {
                    this.regions = response.body.regions;
                });
            },
            getFacilityTypes() {
                this.$callAPI('aafb/facility_types/', {}, function (response) {
                    this.facilityTypes = response.body.item_types;
                });
            },
            getData() {
                this.$callAPI('hkiarace/admin/report/', {
                    report_type: 'ACC_BOOKING_REPORT',
                    params: {
                        from: DateTime.fromISO(this.fromDate).toSeconds(),
                        to: DateTime.fromISO(this.toDate).toSeconds() + 24 * 3600,
                        interval: this.interval,
                        facility_type_id: this.filterOption.facilityTypeId,
                        region_id: this.filterOption.regionId,
                        group_by: this.filterOption.groupBy,
                    },
                }, function (response) {
                    this.rawData = response.body.datasets;
                })
            },
            exportData() {
                this.$downloadFile('hkiarace/admin/report/export/', {
                        report_type: 'ACC_BOOKING_REPORT',
                        params: {
                            from: DateTime.fromISO(this.fromDate).toSeconds(),
                            to: DateTime.fromISO(this.toDate).toSeconds(),
                            interval: this.interval,
                            facility_type_id: this.filterOption.facilityTypeId,
                            region_id: this.filterOption.regionId,
                            group_by: this.filterOption.groupBy,
                        },
                    },
                    'export.xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
            },
        },
    }
</script>

<style>

</style>
